import { Sun, Moon, Monitor } from 'lucide-react'
import { useThemeStore } from '../stores/theme.store'

type ThemeOption = 'light' | 'dark' | 'system'

const options: { value: ThemeOption; icon: React.ReactNode; label: string }[] =
  [
    { value: 'light', icon: <Sun className="h-4 w-4" />, label: 'Light' },
    { value: 'dark', icon: <Moon className="h-4 w-4" />, label: 'Dark' },
    { value: 'system', icon: <Monitor className="h-4 w-4" />, label: 'System' },
  ]

export default function ThemeToggle() {
  const { theme, setTheme } = useThemeStore()

  return (
    <div
      className="flex items-center gap-1 rounded-lg bg-gray-700 dark:bg-gray-800 p-1"
      role="group"
      aria-label="Theme selection"
    >
      {options.map((option) => (
        <button
          key={option.value}
          type="button"
          onClick={() => setTheme(option.value)}
          title={option.label}
          aria-pressed={theme === option.value}
          className={`flex items-center justify-center rounded-md p-1.5 transition-colors ${
            theme === option.value
              ? 'bg-gray-900 dark:bg-gray-600 text-primary-400 shadow-xs'
              : 'text-gray-400 hover:text-gray-200'
          }`}
        >
          {option.icon}
          <span className="sr-only">{option.label}</span>
        </button>
      ))}
    </div>
  )
}
